import { useEffect, useMemo, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaExternalLinkAlt } from 'react-icons/fa';
import './NavbarTop.css';

const internalLinks = [
  { to: '/', label: 'Home', end: true },
  { to: '/my-work', label: 'My Work' },
  { to: '/blog', label: 'Blog' },
  { to: '/about-me', label: 'About Me' },
  // { to: '/art-gallery', label: 'Art Gallery' },
];

const externalLinks = [
  { href: 'https://main.d2wjzzgdwb3l7w.amplifyapp.com/', label: 'My Shop' },
  { href: 'https://main.d2bk2zp4dcjv9g.amplifyapp.com/', label: 'Ski Bookings' },
  { href: 'https://main.d1byw4xc5jg2zw.amplifyapp.com/', label: 'Backstreet Barbers' },
  { href: 'https://main.d2kbu11rec6yhm.amplifyapp.com/login', label: 'SYC Review App' },
  { href: 'https://main.d26ezeixwcqam4.amplifyapp.com/', label: 'Stock dashboard' }
];

export const NavbarTop = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const navLabel = useMemo(() => {
    return isOpen ? 'Close navigation menu' : 'Open navigation menu';
  }, [isOpen]);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.classList.toggle('no-scroll', isOpen);
    return () => document.body.classList.remove('no-scroll');
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, []);

  const closeMenu = () => setIsOpen(false);

  return (
    <>
      <header className="topnav">
        <div className="topnav__shell">
          <Link className="topnav__brand" to="/" aria-label="Miki Pejic home page">
            <span className="topnav__mark" aria-hidden="true">MP</span>
            <span className="topnav__name">Miki Pejic</span>
          </Link>

          <nav className="topnav__desktop" aria-label="Primary navigation">
            <ul className="topnav__list">
              {internalLinks.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    end={item.end}
                    className={({ isActive }) => `topnav__link ${isActive ? 'is-active' : ''}`.trim()}
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>

            <div className="topnav__external">
              {externalLinks.map((item) => (
                <a
                  key={item.href}
                  className="topnav__pill"
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </nav>

          <button
            type="button"
            className={`topnav__toggle ${isOpen ? 'is-open' : ''}`}
            aria-expanded={isOpen}
            aria-controls="topnav-mobile-menu"
            aria-label={navLabel}
            onClick={() => setIsOpen((prev) => !prev)}
          >
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </header>

      <div
        className={`topnav__overlay ${isOpen ? 'is-open' : ''}`}
        onClick={closeMenu}
        aria-hidden={!isOpen}
      >
        <nav
          id="topnav-mobile-menu"
          className="topnav__mobile"
          aria-label="Mobile navigation"
          onClick={(event) => event.stopPropagation()}
        >
          <div className="topnav__mobile-header">
            <span>Menu</span>
            <button type="button" className="topnav__mobile-close" onClick={closeMenu} aria-label="Close menu">
              <FaTimes />
            </button>
          </div>

          <ul className="topnav__mobile-list">
            {internalLinks.map((item) => (
              <li key={`mobile-${item.to}`}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) => `topnav__mobile-link ${isActive ? 'is-active' : ''}`.trim()}
                  onClick={closeMenu}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>

          <p className="topnav__mobile-subtitle">Featured Projects</p>
          <ul className="topnav__mobile-list">
            {externalLinks.map((item) => (
              <li key={`mobile-${item.href}`}>
                <a
                  className="topnav__mobile-link"
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={closeMenu}
                >
                  <span>{item.label}</span>
                  <FaExternalLinkAlt />
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  );
};
